import revive_payload_client_4sVQNw7RlN from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/vsts/work/1/s/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/vsts/work/1/s/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/home/vsts/work/1/s/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/home/vsts/work/1/s/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/vsts/work/1/s/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import clickOutside_0ynIqyw7XJ from "/home/vsts/work/1/s/src/plugins/clickOutside.ts";
import datadogRumClient_rsvCqYJGeT from "/home/vsts/work/1/s/src/plugins/datadogRumClient.ts";
import datalayer_listener_client_hwqEreSLzS from "/home/vsts/work/1/s/src/plugins/datalayer-listener.client.ts";
import fontawesome_CH30yp3mE1 from "/home/vsts/work/1/s/src/plugins/fontawesome.ts";
import siteFetch_0XHuNp6icW from "/home/vsts/work/1/s/src/plugins/siteFetch.ts";
import trackingMiddleWare_HVBPer64lQ from "/home/vsts/work/1/s/src/plugins/trackingMiddleWare.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  clickOutside_0ynIqyw7XJ,
  datadogRumClient_rsvCqYJGeT,
  datalayer_listener_client_hwqEreSLzS,
  fontawesome_CH30yp3mE1,
  siteFetch_0XHuNp6icW,
  trackingMiddleWare_HVBPer64lQ
]